import React from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import HomePage from './pages/HomePage'
import BlogPage from './pages/BlogPage'
import SpecsPage from './pages/SpecsPage'
import HistoryPage from './pages/HistoryPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#FAF8F5]">
        {/* Navigation */}
        <nav className="bg-[#3E2723] border-b border-[#B87333]/20 sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <Link to="/" className="flex items-center space-x-3 group">
                <div className="text-[#F59E0B] text-3xl font-bold tracking-tight group-hover:text-[#B87333] transition-colors">
                  SBB
                </div>
                <div className="text-[#FAF8F5] text-sm font-light hidden sm:block">
                  Single Barrel Bourbon Authority
                </div>
              </Link>
              
              <div className="flex space-x-8">
                <Link to="/" className="text-[#FAF8F5] hover:text-[#F59E0B] transition-colors text-sm font-medium">
                  Home
                </Link>
                <Link to="/reviews" className="text-[#FAF8F5] hover:text-[#F59E0B] transition-colors text-sm font-medium">
                  Reviews
                </Link>
                <Link to="/specs" className="text-[#FAF8F5] hover:text-[#F59E0B] transition-colors text-sm font-medium">
                  Bottle Specs
                </Link>
                <Link to="/history" className="text-[#FAF8F5] hover:text-[#F59E0B] transition-colors text-sm font-medium">
                  History
                </Link>
              </div>
            </div>
          </div>
        </nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reviews" element={<BlogPage />} />
          <Route path="/specs" element={<SpecsPage />} />
          <Route path="/history" element={<HistoryPage />} />
        </Routes>

        {/* Footer */}
        <footer className="bg-[#3E2723] border-t border-[#B87333]/20 mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-[#F59E0B] text-lg font-bold mb-4">About</h3>
                <p className="text-[#FAF8F5]/70 text-sm leading-relaxed">
                  Your trusted source for honest single barrel bourbon reviews, pricing data, and community insights.
                </p>
              </div>
              <div>
                <h3 className="text-[#F59E0B] text-lg font-bold mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li><Link to="/reviews" className="text-[#FAF8F5]/70 hover:text-[#F59E0B] text-sm transition-colors">Community Reviews</Link></li>
                  <li><Link to="/specs" className="text-[#FAF8F5]/70 hover:text-[#F59E0B] text-sm transition-colors">Bottle Database</Link></li>
                  <li><Link to="/history" className="text-[#FAF8F5]/70 hover:text-[#F59E0B] text-sm transition-colors">Bourbon Education</Link></li>
                </ul>
              </div>
              <div>
                <h3 className="text-[#F59E0B] text-lg font-bold mb-4">Disclaimer</h3>
                <p className="text-[#FAF8F5]/70 text-sm leading-relaxed">
                  Drink responsibly. Content is for educational purposes and reflects community opinions.
                </p>
              </div>
            </div>
            <div className="border-t border-[#B87333]/20 mt-8 pt-8 text-center">
              <p className="text-[#FAF8F5]/50 text-sm">© 2024 Single Barrel Bourbon Authority. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default App
